'use client';

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAppState } from '@/lib/useAppState';
import { useVersionTree } from '@/components/versions/useVersionTree';
import { evalRunsByScenarioKey, fetchEvalRunsByScenario } from '@/lib/evalRunsQuery';
import { renderEvalStatus, renderTextMultiline } from '@/lib/renderFunctions';

/** An eval scenario's result or reply on the version picked in the version picker; every cell shares one request. */
export function EvalSelectedVersionCell({ scenarioId, show }: { scenarioId: number; show: 'status' | 'response' }) {
	const workspace = useAppState((s) => s.currentWorkspace?.slug);
	const agent = useAppState((s) => s.currentAgent?.slug);
	const versionId = useVersionTree((s) => s.selectedVersionId);

	const { data, isLoading } = useQuery({
		queryKey: evalRunsByScenarioKey(workspace ?? '', agent ?? '', versionId ?? 0),
		queryFn: () => fetchEvalRunsByScenario(workspace!, agent!, versionId!),
		enabled: Boolean(workspace && agent && versionId),
	});

	if (!versionId || isLoading) return null;
	const run = data?.get(scenarioId);
	if (!run?.status) return <span className="text-xs text-muted-foreground">not run</span>;
	if (show === 'response') return renderTextMultiline(run.response);
	return <span title={run.reason ?? undefined}>{renderEvalStatus(run.status)}</span>;
}
